import { schema, } from '@verdant-web/common';
const otherDefaults = {
    content: [],
    marks: null,
    attrs: {},
    from: null,
    to: null,
    text: null,
};
/**
 * Creates a generic TipTap schema field. You must invoke this and assign it
 * individually to every TipTap document field in your schema, DO NOT reuse
 * the same instance for multiple fields.
 */
export function createTipTapFieldSchema(options) {
    if (options.default === undefined) {
        throw new Error('createTiptapFieldSchema requires a default value. Specify "null" to make the field nullable.');
    }
    const baseField = schema.fields.object({
        fields: {},
    });
    const nestedContent = schema.fields.replaceObjectFields(baseField, {
        type: schema.fields.string(),
        from: schema.fields.number({ nullable: true }),
        to: schema.fields.number({ nullable: true }),
        attrs: schema.fields.map({
            values: schema.fields.any(),
        }),
        content: schema.fields.array({
            items: baseField,
            nullable: true,
        }),
        text: schema.fields.string({ nullable: true }),
        marks: schema.fields.array({
            items: baseField,
            nullable: true,
        }),
    });
    const rootField = schema.fields.object({
        fields: {
            type: schema.fields.string(),
            from: schema.fields.number({ nullable: true }),
            to: schema.fields.number({ nullable: true }),
            attrs: schema.fields.map({
                values: schema.fields.any(),
            }),
            content: schema.fields.array({
                items: nestedContent,
                nullable: true,
            }),
            text: schema.fields.string({ nullable: true }),
            marks: schema.fields.array({
                items: nestedContent,
                nullable: true,
            }),
        },
        default: () => {
            if (options.default === null) {
                return null;
            }
            return Object.assign(Object.assign({}, otherDefaults), structuredClone(options.default));
        },
        nullable: options.default === null,
    });
    return rootField;
}
export function createTipTapFileMapSchema() {
    return schema.fields.map({
        values: schema.fields.file(),
    });
}
//# sourceMappingURL=fields.js.map